export const VAT_MAX_COUNTRY_ID = 49;
export const EXCISE_MIN_COUNTRY_ID = 50;
export const VAT_PRODUCT_TYPE = 1;
export const EXCISE_PRODUCT_TYPE = 2;

export const isCountryValidForProduct = (countryId, productType) => {
  const parsedCountryId = Number(countryId);
  const parsedProductType = Number(productType);
  if (!Number.isFinite(parsedCountryId) || !Number.isFinite(parsedProductType)) {
    return false;
  }

  if (parsedProductType === EXCISE_PRODUCT_TYPE) {
    return parsedCountryId >= EXCISE_MIN_COUNTRY_ID;
  }

  if (parsedProductType === VAT_PRODUCT_TYPE) {
    return parsedCountryId <= VAT_MAX_COUNTRY_ID;
  }

  return false;
};

export const filterCountriesForProduct = (countries, productType) => {
  const parsedProductType = Number(productType);
  if (!parsedProductType) {
    return [];
  }

  if (parsedProductType === EXCISE_PRODUCT_TYPE) {
    return countries.filter((country) => country.countryId >= EXCISE_MIN_COUNTRY_ID);
  }

  if (parsedProductType === VAT_PRODUCT_TYPE) {
    return countries.filter((country) => country.countryId <= VAT_MAX_COUNTRY_ID);
  }

  return [];
};

export const getCountryProductHelperText = (productType) => {
  if (!productType) {
    return "Select a product first";
  }

  if (Number(productType) === EXCISE_PRODUCT_TYPE) {
    return "Only excise countries are available for Excise refund rates";
  }

  return "Only VAT countries are available for VAT refund rates";
};
